import CustomDropdown from "../../components/forms/CustomDropdown";
import { semesterAttestationTypesApi } from "../../services/nomenclatures/semesterAttestationTypesApi";
import CustomInputText from "../../components/forms/CustomInputText";
import CustomDatepicker from "../../components/forms/CustomDatepicker";
import { academicYearsApi } from "../../services/nomenclatures/academicYearsApi";

interface SemesterAttestationFormFieldsProps {
  className?: string;
}

const SemesterAttestationFormFields = ({ className = "" }: SemesterAttestationFormFieldsProps) => {
  const { data: semesterAttestationTypes } = semesterAttestationTypesApi.useGetSemesterAttestationTypesQuery();
  const { data: academicYears } = academicYearsApi.useGetAcademicYearsQuery();

  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      <div className="flex-1">
        <CustomDropdown
          id="semesterAttestationTypeId"
          name="semesterAttestationTypeId"
          label="Тип заверка"
          options={semesterAttestationTypes?.data ?? []}
          optionLabel="name"
          optionValue="semesterAttestationTypeId"
          placeholder="Изберете опция"
        />
      </div>
      <div className="flex-1">
        <CustomInputText id="semester" name="semester" label="Семестър" type="number" />
      </div>
      <div className="flex-1">
        <CustomDropdown
          id="academicYearId"
          name="academicYearId"
          label="Учебна година"
          options={academicYears?.data ?? []}
          optionLabel="name"
          optionValue="academicYearId"
          placeholder="Изберете година"
        />
      </div>
      <div className="flex-1">
        <CustomDatepicker id="attestationDate" name="attestationDate" label="Дата на заверка" dateFormat="dd.mm.yy" />
      </div>
    </div>
  );
};

export default SemesterAttestationFormFields;
